import { useState } from 'react';
import { Button, Modal, Form, Select } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';

const AddUserModal = ({ onFinish, usersOptions }) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await onFinish(values);
      form.resetFields();
      setVisible(false);
    } catch (error) {
      console.error('Ошибка при добавлении пользователей:', error);
    }
  };

  return (
    <>
      <Button type='primary' onClick={() => setVisible(true)} icon={<UserAddOutlined />}>
        Добавить пользователя
      </Button>
      <Modal
        title='Выберите пользователей'
        open={visible}
        onOk={handleOk}
        onCancel={() => setVisible(false)}
        cancelText='Отмена'
      >
        <Form form={form}>
          <Form.Item label='Позывной' name='names'>
            <Select
              mode='multiple'
              showSearch
              filterOption={(input, option) =>
                option.label && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder='Выберите пользователей для групповой трансляции'
              style={{ width: '100%' }}
              options={usersOptions}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddUserModal;
